import { ChangeDetectorRef } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HTTPStatus } from './common/app-token-handler';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    iSLoading: boolean;
    constructor(private router: Router,private httpStatus: HTTPStatus,private cdRef: ChangeDetectorRef) {
        this.httpStatus.getHttpStatus().subscribe((status: boolean) => { this.iSLoading = status; });
    }
    ngOnInit() {
    }
    ngAfterViewChecked() {
        this.httpStatus.getHttpStatus().subscribe((status: boolean) => {
          this.iSLoading = status;
        });
        this.cdRef.detectChanges();
      }
}
